function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// @ts-nocheck
import React, { useContext, useState } from 'react';
import { NtqToolbarContext } from "./NtqToolbarProvider";
import styles from "./index.module.css";
import { Col, Popover, Row, Spin } from 'antd';
var defaultOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  }
};
var Impersonation = function Impersonation(props) {
  var config = useContext(NtqToolbarContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    users = _useState6[0],
    setUsers = _useState6[1];
  var onOpenChange = function onOpenChange(visible) {
    if (visible) {
      setOpen(true);
      if (!users) {
        setLoading(true);
        fetch("".concat(config.baseUrl, "/impersonation/users.json"), _objectSpread({}, defaultOptions)).then(function (response) {
          return response.json();
        }).then(function (_ref) {
          var data = _ref.data;
          setUsers(data);
          setLoading(false);
        }).catch(function () {
          setLoading(false);
        });
      } else setOpen(true);
    } else setOpen(false);
  };
  var onUserClick = function onUserClick(modelName, user) {
    window.location.href = "".concat(config.baseUrl, "/impersonation/").concat(modelName, "/").concat(user.id, "/sign_in");
  };
  var modelNames = Object.keys(users || {}).filter(function (m) {
    var _config$impersonation;
    return !(config !== null && config !== void 0 && (_config$impersonation = config.impersonation) !== null && _config$impersonation !== void 0 && _config$impersonation.userTypes) || config.impersonation.userTypes.includes(m);
  });
  var hasManyModels = modelNames.length > 0;
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement("div", {
    className: styles.popoverLoading
  }, /*#__PURE__*/React.createElement(Spin, null)), !loading && users && /*#__PURE__*/React.createElement("div", {
    className: styles.popoverContent
  }, modelNames.map(function (modelName) {
    return /*#__PURE__*/React.createElement(Row, {
      key: modelName,
      className: styles.userGroup
    }, hasManyModels && /*#__PURE__*/React.createElement(Col, {
      className: styles.impersonationModelName,
      span: 24
    }, modelName), users[modelName].map(function (user) {
      return /*#__PURE__*/React.createElement(Col, {
        key: user.id,
        className: "".concat(styles.user, " ").concat(hasManyModels ? styles.padded : ''),
        span: 24,
        onClick: function onClick() {
          return onUserClick(modelName, user);
        }
      }, user.label);
    }));
  })));
  return /*#__PURE__*/React.createElement(Popover, {
    trigger: ['click'],
    open: open,
    content: content,
    onOpenChange: onOpenChange,
    placement: "bottom",
    arrowPointAtCenter: true
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.tag
  }, "Connexion utilisateur"));
};
export default Impersonation;